export default "__VITE_ASSET__BfbSmY5w__"